// dropdown เลือกแคมเปญ — ใช้ร่วมกันทุกหน้าที่ scope ตามแคมเปญ
// ค่าที่เลือกเก็บใน query string (?campaign=) เพื่อให้ refresh/แชร์ลิงก์แล้วได้ scope เดิม
import { useSearchParams } from "react-router";
import type { Campaign } from "@contracts/api";

export function CampaignSelect({
  campaigns,
  showCount = false,
}: {
  campaigns: Campaign[];
  /** true = ใส่จำนวนแคมเปญในตัวเลือก "ทุกแคมเปญ" (หน้า Dashboard ทำแบบนั้น) */
  showCount?: boolean;
}) {
  const [params, setParams] = useSearchParams();
  const value = params.get("campaign") ?? "";

  return (
    <label className="camp-select-wrap">
      <span className="muted camp-select-lbl">Campaign</span>
      <select
        className="camp-select"
        value={value}
        onChange={(e) => {
          const next = new URLSearchParams(params);
          if (e.target.value) next.set("campaign", e.target.value);
          else next.delete("campaign");
          // เปลี่ยนแคมเปญ = เปลี่ยน scope ของทั้งหน้า → ref เดิมใช้ไม่ได้แล้ว
          next.delete("ref");
          setParams(next, { replace: true });
        }}
      >
        <option value="">ทุกแคมเปญ{showCount ? ` (${campaigns.length})` : ""}</option>
        {campaigns.map((c) => (
          <option key={c.id} value={c.id}>
            {c.name}
          </option>
        ))}
      </select>
    </label>
  );
}
